import client from './client'
import type { TeamMember, UpdateMemberRolePayload } from '@/types/team'

const base = (organisationId: number): string =>
  `/organizer/organisations/${organisationId}/members`

export async function listMembers(organisationId: number): Promise<TeamMember[]> {
  const { data } = await client.get<{ data: TeamMember[] }>(base(organisationId))
  return data.data
}

export async function updateMemberRole(
  organisationId: number,
  userId: number,
  payload: UpdateMemberRolePayload,
): Promise<TeamMember> {
  const { data } = await client.patch<{ data: TeamMember }>(
    `${base(organisationId)}/${userId}`,
    payload,
  )
  return data.data
}

export async function removeMember(organisationId: number, userId: number): Promise<void> {
  await client.delete(`${base(organisationId)}/${userId}`)
}
